import { CommuneService } from "../../services/models/commune";
const moduleCommune = {
	namespaced: true,
	state: {
		communes: [],
		loading: false,
	},
	getters: {
		getCommunes(state) {
			return state.communes;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadCommunes(state, communes) {
			state.communes = communes;
		}
	},
	actions: {
		async loadCommunes({ commit, state }) {
			state.loading = true;
			let communes = await CommuneService.getAll();
			commit("loadCommunes", communes);
			state.loading = false;
		}
	}
}

export default moduleCommune;